import React from 'react'
import Experiment, { useBucket } from '@mc/experiments-react'
import OriginalLoginForm from '../../../components/LoginForm/LoginForm'
import { useLoginReminder } from '../hooks/useLoginReminder'
import { setAuthAttemptFlag } from '../utils/lastLoginMethod'
import LoginFormExperiment from './LoginForm'

export interface LoginFormExperimentContainerProps {
  onSubmit: (data: unknown) => Promise<unknown>
  onForgotPasswordClick: () => void
  onRegisterClick: () => void
  facebookLogin: () => void
  appleLogin: () => void
  nextPage?: string
  thirdPartyError?: string
  userAgent?: string
}

export const LoginFormExperimentContainer: React.FC<
  LoginFormExperimentContainerProps
> = (props) => {
  const bucket = useBucket('post-pw-ce-3448-last-login-reminder')
  const isExperimentParticipant = bucket === 'control' || bucket === 'variant_1'
  const isVariant = bucket === 'variant_1'

  const { handleLoginMethodClick, handleForgotPasswordClick } =
    useLoginReminder()

  const wrappedOnSubmit = async (data: unknown) => {
    if (isExperimentParticipant) {
      handleLoginMethodClick('email')
    }
    return (props.onSubmit as (data: unknown) => Promise<unknown>)(data)
  }

  const wrappedForgotPasswordClick = () => {
    if (isExperimentParticipant) {
      handleForgotPasswordClick()
    }
    props.onForgotPasswordClick()
  }

  const wrappedFacebookLogin = () => {
    if (isExperimentParticipant) {
      handleLoginMethodClick('facebook')
    }
    props.facebookLogin()
  }

  const wrappedAppleLogin = (data: unknown) => {
    if (isExperimentParticipant) {
      handleLoginMethodClick('apple')
    }
    ;(props.appleLogin as (data: unknown) => void)(data)
  }

  const wrappedGoogleLogin = () => {
    if (isExperimentParticipant) {
      handleLoginMethodClick('google')
    }
  }

  const wrappedRegisterClick = () => {
    if (isExperimentParticipant) {
      setAuthAttemptFlag('signup')
    }
    props.onRegisterClick()
  }

  const wrappedEmailToggleExpand = () => {
    if (isExperimentParticipant) {
      handleLoginMethodClick('email', 'expand-email-login')
    }
  }

  return (
    <Experiment
      name='post-pw-ce-3448-last-login-reminder'
      control={OriginalLoginForm}
      variant_1={LoginFormExperiment}
      {...props}
      onSubmit={wrappedOnSubmit as (data?: unknown) => Promise<unknown> | void}
      onForgotPasswordClick={wrappedForgotPasswordClick}
      facebookLogin={wrappedFacebookLogin as () => void}
      appleLogin={wrappedAppleLogin as () => void}
      googleLogin={wrappedGoogleLogin as () => void}
      onRegisterClick={wrappedRegisterClick as () => void}
      {...(isVariant
        ? {
            onEmailToggleExpand: wrappedEmailToggleExpand,
          }
        : {})}
    />
  )
}
